module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_18.fbf0008d.png";